export default __webpack_public_path__ + "static/media/branding-bold-webfont.b73e02ff.woff";